import { useTranslation } from '../../i18n';
import { Button } from '../ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';

interface IAdminTransferDialogProps {
  isOpen: boolean;
  message: string;
  isLoading: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const AdminTransferDialog = ({
  isOpen,
  message,
  isLoading,
  onConfirm,
  onCancel,
}: IAdminTransferDialogProps) => {
  const { t } = useTranslation();

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onCancel()}>
      <DialogContent className="sm:max-w-[420px]">
        <DialogHeader>
          <DialogTitle>{t('admin.transfer_title')}</DialogTitle>
          <DialogDescription>{message}</DialogDescription>
        </DialogHeader>
        <p className="text-sm text-red-600">{t('admin.transfer_warning')}</p>
        <DialogFooter>
          <Button variant="outline" onClick={onCancel}>
            {t('common.cancel')}
          </Button>
          <Button
            variant="destructive"
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading ? t('common.saving') : t('admin.confirm_transfer')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default AdminTransferDialog;
